import React from "react";
import ShipmentFilters from "../../components/Fullfilment/supplierfulfillment/ShipmentFilters";
import ShipmentTable from "../../components/Fullfilment/supplierfulfillment/ShipmentTable";
import ShipmentDetailModal from "../../components/Fullfilment/supplierfulfillment/ShipmentDetailModal";
import { useSupplierProcessingStore } from "../../store/useSupplierProcessingStore.ts";

const SupplierShipmentFulfillment = () => {
    const totalCount = useSupplierProcessingStore((s) => s.totalCount);
  return (
      <div style={{padding: 24}}>
          <header className="flex justify-between items-center mb-8">
              <h1 className="text-3xl font-extrabold text-gray-900">
                  پنل پردازش سفارشات
              </h1>

              <div className="text-sm text-gray-500 bg-gray-100 px-4 py-2 rounded-full">
                  تعداد کل: {totalCount} مورد
              </div>
          </header>

          <ShipmentFilters/>

          <ShipmentTable/>

          <ShipmentDetailModal/>
      </div>
  );
};

export default SupplierShipmentFulfillment;
